import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
                Building Tech. Building Community.
               </h3>
               <p className="c-para"> What Makes This Training Unique: It combines hands-on engineering with real-world problem-solving, preparing youth to design robotics and electronics that serve community needs.</p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Robotics Engineering Skills'}
                  text={'This training equips participants with the knowledge and skills needed to pursue robotics engineering:'}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Designing, assembling, and programming robots'}
                  text2={'Understanding mechanical systems, electronics, and sensors'}
                  text3={'Learn about the engineering design process.'}
                  text4={'Get hands-on experience by working individually and in groups to design and develop both simple and complex projects.'}
                  text5={'Testing, maintaining, and improving robotic systems'}
                  text6={' Understanding multidisciplinary approaches to effectively design and build robots.'}
               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
